"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "course_zlb": {
    "allCourses": "វគ្គសិក្សាទាំងអស់",
    "className": "ឈ្មោះសិក្ខាសាលា",
    "continue": "បន្ត",
    "courseChapter": "ជំពូក",
    "courseEvaluate": "ការវាយតម្លៃ",
    "courseHours": "ក្រេឌីត",
    "courseInfo": "ព័ត៍មានលម្អិត",
    "courseNote": "កំណត់ចំណាំ",
    "coursesCategory": "ប្រភេទវគ្គសិក្សា",
    "electiveCourses": "វគ្គសិក្សាជាជម្រើស",
    "pages": "ទំព័រ",
    "relatedCourses": "វគ្គសិក្សាដែលពាក់ព័ន្ធ",
    "requiredCourses": "ការបង្រៀន",
    "searchTips": "សូមបញ្ចូលឈ្មោះវគ្គសិក្សា",
    "studentsNum": "ទស្សនិកជន",
    "teachersDesc": "គ្រូបង្រៀន",
    "newCourse": "វគ្គសិក្សាចុងក្រោយ"
  },
  "footer_zlb": {
    "aboutUs": "អំពីយើង",
    "downLoad": "ទាញយកកម្មវិធី",
    "qr": "កូដ QR"
  },
  "global_zlb": {
    "am": "AM",
    "night": "ល្ងាច",
    "pm": "PM"
  },
  "header_zlb": {
    "accoutPw": "ពាក្យសម្ងាត់គណនី",
    "curDis": "កំពុងបន្ត",
    "curUser": "អ្នកប្រើប្រាស់បច្ចុប្បន្ន",
    "edit": "បច្ចុប្បន្នភាព",
    "helpCenter": "មជ្ឈមណ្ឌល​ជំនួយ",
    "hisDis": "ប្រវត្តិ",
    "index": "ទំព័រដើម",
    "joinStore": "ដាក់ចូលចំណូលចិត្ត",
    "logo": require('@/static/images/index_zlb/logo.png'),
    "logoText": require('@/static/images/index_zlb/logo-t.png'),
    "message": "សារ",
    "setIndex": "កំណត់ជាទំព័រដើម",
    "userImg": "រូបភាពប្រវត្តិរូប"
  },
  "index_zlb": {
    "discuss": "សិក្ខាសាលា",
    "find": "ស្វែងយល់",
    "textImg": require('@/static/images/index_zlb/text.png'),
    "userCenter": "ខ្ញុំ"
  },
  "info_zlb": {
    "admin": "អ្នកគ្រប់គ្រង",
    "hasAgenda": "អ្នកបានចូលរួមក្នុងរបៀបវារៈរួចហើយ។",
    "noDown": "មិនមានឯកសារភ្ជាប់ដើម្បីទាញយកទេ!",
    "pleaseInp": "សូមបញ្ចូល",
    "submit": "បានដាក់ស្នើដោយជោគជ័យ!",
    "withinTime": "កិច្ចការមិនទាន់ចាប់ផ្តើមនៅឡើយទេ",
    "noSubmitWork": "កិច្ចការមិនបានដាក់ស្នើទេ"
  },
  "login_zlb": {
    "accountLogin": "ចូល",
    "accountNotEmpty": "គណនីត្រូវតែបំពេញ",
    "bg": require('@/static/images/login_zlb/login_bg.jpg'),
    "bian": require('@/static/images/login_zlb/bianzu.png'),
    "cancel": "បោះបង់",
    "captchaNotEmpty": "លេខកូដផ្ទៀងផ្ទាត់ត្រូវតែបំពេញ",
    "captchaTips": "លេខកូដផ្ទៀងផ្ទាត់មិនត្រឹមត្រូវ",
    "changeEmail": "ធ្វើបច្ចុប្បន្នភាពអ៊ីម៉ែល",
    "changeEmailSuccess": "អាសយដ្ឋានអ៊ីម៉ែលត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ។",
    "changeEmailSuccessTips": "អ្នកបានធ្វើបច្ចុប្បន្នភាពអ៊ីម៉ែលរបស់អ្នកដោយជោគជ័យ។",
    "Confirm": "បញ្ជាក់",
    "currentEmail": "អ៊ីម៉ែលបច្ចុប្បន្ន",
    "emailCaptcha": "លេខកូដផ្ទៀងផ្ទាត់អ៊ីម៉ែល",
    "emailCaptchaEmpty": "លេខកូដផ្ទៀងផ្ទាត់អ៊ីម៉ែលមិនអាចទទេបានទេ",
    "encryEmail": "សុវត្ថិភាពអ៊ីម៉ែល",
    "error": "កំហុសលេខកូដផ្ទៀងផ្ទាត់",
    "forget": "ភ្លេចពាក្យសម្ងាត់",
    "formerEamil": "អ៊ីម៉ែលដើម",
    "incorrectTips": "កំហុសក្នុងការបញ្ចូលឈ្មោះអ្នកប្រើប្រាស់ ឬពាក្យសម្ងាត់",
    "logo": require('@/static/images/login_zlb/logo.png'),
    "newEmail": "អ៊ី​ម៉ែ​ល​ថ្មី",
    "newEmailBinded": "អ៊ីម៉ែលថ្មីត្រូវបានភ្ជាប់ទៅគណនីអ្នកប្រើប្រាស់របស់អ្នក",
    "newEmailEmpty": "អ៊ីម៉ែលថ្មីមិនអាចទទេបានទេ",
    "newEmailFomat": "ទម្រង់អ៊ីម៉ែលថ្មីមិនត្រឹមត្រូវ",
    "newEmailSupport": "អាសយដ្ឋានអ៊ីម៉ែលចាស់និងថ្មីមិនត្រូវគ្នាទេ",
    "prevStep": "ជំហានចុងក្រោយ",
    "nextStep": "ជំហានបន្ទាប់",
    "reset": "កំណត់ឡើងវិញ",
    "loginNow": "ចូលឥឡូវនេះ",
    "resetSuccess": "កំណត់ឡើងវិញបានជោគជ័យ",
    "resetSuccessTips": "អ្នកបានកំណត់ពាក្យសម្ងាត់របស់អ្នកឡើងវិញដោយជោគជ័យ។ សូមទៅកន្លែងចូល",
    "msgCaptcha": "លេខកូដផ្ទៀងផ្ទាត់ SMS",
    "getCaptcha": "ទទួលលេខកូដផ្ទៀងផ្ទាត់",
    "resetPassword": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
    "loginFail": "ការចូលបានបរាជ័យ។ សូមព្យាយាមម្តងទៀត!",
    "failTips": "ការផ្ទៀងផ្ទាត់បានបរាជ័យ",
    "inputUserName": "ឈ្មោះអ្នកប្រើប្រាស់",
    "goHome": "ទៅទំព័រដើម",
    "passwordFormat": "ពាក្យសម្ងាត់ត្រូវតែមាន 8-32 ខ្ទង់ ហើយមានលេខ និងអក្សរធំ និងអក្សរតូច។",
    "surePasswordEmpty": "ពាក្យសម្ងាត់បញ្ជាក់មិនអាចទទេបានទេ",
    "confirmNot": "ពាក្យសម្ងាត់ និងពាក្យសម្ងាត់បញ្ជាក់មិនត្រូវគ្នាទេ",
    "changePasswordSuccess": "ពាក្យសម្ងាត់ត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ",
    "continueLogin": "ចូលម្តងទៀត",
    "orError": "ឈ្មោះអ្នកប្រើប្រាស់ ឬពាក្យសម្ងាត់មិនត្រឹមត្រូវ",
    "orgEmailEmpty": "អ៊ីម៉ែលដើមមិនអាចទទេបានទេ",
    "orgEmailFormat": "ទម្រង់អ៊ីម៉ែលដើមមិនត្រឹមត្រូវទេ",
    "orgEmailNot": "អាសយដ្ឋានអ៊ីម៉ែលដើមមិនត្រឹមត្រូវទេ",
    "passWord": "ពាក្យសម្ងាត់",
    "surePassword": "ពាក្យសម្ងាត់បញ្ជាក់",
    "passwordBits": "ពាក្យសម្ងាត់ត្រូវតែមានយ៉ាងតិច 6 តួអក្សរ",
    "passwordNotEmpty": "ពាក្យសម្ងាត់ត្រូវតែបំពេញ",
    "pWord": "ពាក្យសម្ងាត់",
    "sign": "ចូល",
    "uName": "គណនី",
    "userName": "ឈ្មោះអ្នកប្រើប្រាស់",
    "validate": "លេខកូដផ្ទៀងផ្ទាត់",
    "verification": "សូមបំពេញការផ្ទៀងផ្ទាត់ខាងក្រោម",
    "appdownload": "ទាញយកកម្មវិធី",
    "scancode": "ស្កេនលេខកូដ QR ដើម្បីទាញយក",
    "poor": "ខ្សោយ",
    "middle": "មធ្យម",
    "strong": "ខ្លាំង"
  },
  "login": {
    "logout": "ចេញដោយជោគជ័យ",
    "resetLoginTips": "អ្នកបានផ្លាស់ប្តូរពាក្យសម្ងាត់របស់អ្នកដោយជោគជ័យ។ អ្នកត្រូវចូលម្តងទៀតហើយចេញដោយស្វ័យប្រវត្តិបន្ទាប់ពី 3 វិនាទី",
    "sure": "បញ្ជាក់",
    "cancel": "បោះបង់",
    "captchaNotEmpty": "លេខកូដផ្ទៀងផ្ទាត់ត្រូវតែបំពេញ",
    "accountNotEmpty": "គណនីត្រូវតែបំពេញ",
    "passwordNotEmpty": "ពាក្យសម្ងាត់ត្រូវតែបំពេញ",
    "inputCaptcha": "លេខកូដផ្ទៀងផ្ទាត់",
    "getCaptcha": "ទទួលលេខកូដផ្ទៀងផ្ទាត់",
    "inputOrigPassword": "សូមបញ្ចូលពាក្យសម្ងាត់ដើម",
    "inputNewPassowrd": "សូមបញ្ចូលពាក្យសម្ងាត់ថ្មី",
    "confimPassword": "ពាក្យសម្ងាត់បញ្ជាក់",
    "changePassword": "ផ្លាស់ប្តូរពាក្យសម្ងាត់",
    "nextStep": "ជំហានបន្ទាប់",
    "resetPassword": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
    "resetDone": "កំណត់ពាក្យសម្ងាត់ឡើងវិញបានជោគជ័យ",
    "msgCaptcha": "លេខកូដផ្ទៀងផ្ទាត់អ៊ីម៉ែល"
  },
  "look_zlb": {
    "aboutLecturer": "វគ្គសិក្សាដែលពាក់ព័ន្ធ",
    "benginLearn": "ចាប់ផ្តើមរៀន",
    "chapter": "ជំពូក",
    "delete": "លុបចោល",
    "details": "ព័ត៍មានលម្អិត",
    "download": "ទាញយក",
    "dynamic": "ព័ត៍មាន",
    "evaluation": "ការវាយតម្លៃ",
    "hotDyc": "និន្នាការ",
    "lecture": "បើកវគ្គសិក្សា",
    "lecturer": "គ្រូបង្រៀន",
    "lectureTest": "ប្រភេទវគ្គសិក្សា",
    "look": "ស្វែងយល់",
    "lookAll": "បើកមើលទាំងអស់",
    "note": "កំណត់ចំណាំ",
    "score": "ពិន្ទុ"
  },
  "myMessage_zlb": {
    "passwordError": "កំហុសក្នុងការបញ្ចូលពាក្យសម្ងាត់ដើម",
    "aboutUs": "អំពីយើង",
    "allcourse": "វគ្គសិក្សាទាំងអស់",
    "atypism": "ពាក្យសម្ងាត់ទាំងពីរមិនត្រូវគ្នាទេ",
    "birth": "ថ្ងៃខែ​ឆ្នាំ​កំណើត",
    "cancel": "បោះបង់",
    "carryOut": "បញ្ចប់",
    "changePassword": "ផ្លាស់ប្តូរពាក្យសម្ងាត់",
    "chineseName": "ឈ្មោះជាភាសាចិន",
    "chineseNamePlaceholder": "សូមបញ្ចូលឈ្មោះជាភាសាចិន",
    "code": "លេខកូដ​ផ្ទៀង​ផ្ទាត់",
    "codeError": "កំហុសលេខកូដផ្ទៀងផ្ទាត់",
    "comment": "មតិ",
    "complete": "បញ្ចប់",
    "completeUserInfo": "សូមបំពេញព័ត៌មានផ្ទាល់ខ្លួន",
    "confirm": "ពាក្យសម្ងាត់បញ្ជាក់",
    "continueStudy": "បន្ត",
    "country": "ប្រទេស",
    "countryName": "ឈ្មោះ",
    "countryNamePlaceholder": "សូម​បញ្ចូល​ឈ្មោះ​របស់​អ្នក",
    "countryPlaceholder": "សូមជ្រើសរើសប្រទេស",
    "courseLearned": "បានបញ្ចប់",
    "delete": "លុបចោល",
    "documentType": "ប្រភេទឯកសារអត្តសញ្ញាណប័ណ្ណ",
    "downloaded": "បានទាញយក",
    "downloading": "កំពុងទាញយក",
    "eduLevel": "កម្រិត​ការ​អប់រំ",
    "eduLevelPlaceholder": "សូមជ្រើសរើសកម្រិត​ការ​អប់រំ",
    "email": "អ៊ីម៉ែល",
    "emailCode": "លេខកូដផ្ទៀងផ្ទាត់អ៊ីម៉ែល",
    "gender": "ភេទ",
    "genderPlaceholder": "សូមជ្រើសរើសភេទ",
    "getCode": "ទទួលបានលេខកូដផ្ទៀងផ្ទាត់អ៊ីម៉ែល",
    "hasSent": "បានផ្ញើ",
    "helpCenter": "មជ្ឈមណ្ឌល​ជំនួយ",
    "hour": "ម៉ោង",
    "improveInformation": "សូមបំពេញព័ត៌មានផ្ទាល់ខ្លួនរបស់អ្នក",
    "joinClasses": "វគ្គសិក្សាដែលបានចូលរួម",
    "joinDis": "សិក្ខាសាលាដែលបានចូលរួម",
    "learned": "បញ្ចប់ហើយ",
    "learning": "កំពុង​ដំណើរការ",
    "lecture": "វគ្គសិក្សា",
    "mailbox": "អ៊ីម៉ែល",
    "mailboxValidate": "ការផ្ទៀងផ្ទាត់អ៊ីម៉ែលបានបរាជ័យ",
    "man": "ប្រុស",
    "management": "ការកំណត់",
    "minutes": "x ម៉ោង x នាទី",
    "modify": "បច្ចុប្បន្នភាព",
    "modifyEmail": "ធ្វើបច្ចុប្បន្នភាពអ៊ីម៉ែល",
    "my": "ខ្លួនខ្ញុំ",
    "myCertificate": "វិញ្ញាបនប័ត្ររបស់ខ្ញុំ",
    "mycourse": "វគ្គសិក្សារបស់ខ្ញុំ",
    "myDownload": "ការទាញយករបស់ខ្ញុំ",
    "myLecture": "វគ្គសិក្សារបស់ខ្ញុំ",
    "myNotes": "កំណត់ចំណាំរបស់ខ្ញុំ",
    "newMail": "អ៊ី​ម៉ែ​ល​ថ្មី",
    "newPassword": "ពាក្យសម្ងាត់​ថ្មី",
    "nextStep": "ជំហានបន្ទាប់",
    "orError": "ឈ្មោះអ្នកប្រើប្រាស់ ឬពាក្យសម្ងាត់មិនត្រឹមត្រូវ",
    "origin": "ពី",
    "originalPassword": "ពាក្យសម្ងាត់ដើម",
    "password": "ពាក្យសម្ងាត់",
    "phone": "លេខទូរស័ព្ទ",
    "pleChoose": "សូមជ្រើសរើសថ្ងៃខែឆ្នាំកំណើត",
    "post": "ប្រកាស",
    "postPlaceholder": "សូមបញ្ចូលប្រកាស",
    "religion": "សាសនា",
    "religionPlaceholder": "សូមជ្រើសរើសសាសនា",
    "retrievePassword": "ស្តារយកពាក្យសម្ងាត់",
    "setUp": "ការកំណត់",
    "signOut": "ចេញ",
    "something": "ខ្ញុំចង់និយាយថា",
    "submit": "ដាក់ស្នើ",
    "sureDelte": "សូមប្រាកដថាអ្នកចង់លុបវាចោល?",
    "teacher": "សាស្ត្រាចារ្យ",
    "learnYet": "មិនទាន់បានចាប់ផ្តើមរៀននៅឡើយទេ",
    "uName": "ឈ្មោះអ្នកប្រើប្រាស់",
    "uNamePlaceholder": "ឈ្មោះអ្នកប្រើប្រាស់",
    "userCenter": "ព័ត៌មានផ្ទាល់ខ្លួន",
    "username": "ឈ្មោះអ្នកប្រើប្រាស់",
    "validateMsg": "ការផ្ទៀងផ្ទាត់បានបរាជ័យ",
    "woman": "ស្រី",
    "learnTo": "វឌ្ឍនភាព",
    "myRecord": "កំណត់ត្រារបស់ខ្ញុំ",
    "plePhone": "សូមបញ្ចូលលេខទូរស័ព្ទ"
  },
  "notice_zlb": {
    "delete": "លុបចោល",
    "home": "ទំព័រដើម",
    "lettre": "សារ​ជា​ឯកជន",
    "lettreEmpty": "សារជាឯកជនមិនអាចទទេបានទេ",
    "messageDetail": "ព័ត៌មានលម្អិតសារ",
    "myMessage": "សាររបស់ខ្ញុំ",
    "notice": "សេចក្តីជូនដំណឹង",
    "nowBavarder": "ឥឡូវអ្នកអាចចាប់ផ្តើមជជែកគ្នា",
    "send": "ផ្ញើ"
  },
  "play_zlb": {
    "networkTip": "ការជូនដំណឹងបណ្តាញ",
    "streamHighTip": "ការភ្ជាប់បណ្តាញបច្ចុប្បន្នមានស្ថេរភាព។ យើងបានប្តូរទៅរបៀបកម្រិតច្បាស់សម្រាប់អ្នក។",
    "streamHighType": "HD",
    "streamNormTip": "ការភ្ជាប់បណ្តាញបច្ចុប្បន្នមិនមានស្ថិតស្ថេរ។ យើងបានប្តូរទៅរបៀបកម្រិតស្តង់ដារសម្រាប់អ្នក។",
    "streamNormType": "SD",
    "liveTimeDes": "ពេលវេលាផ្សាយផ្ទាល់",
    "livePlayWait": "ការផ្សាយបន្តផ្ទាល់មិនបានចាប់ផ្តើមទេ",
    "livePlayEnd": "ការផ្សាយបន្តផ្ទាល់បានបញ្ចប់"
  },
  "questionnaire_zlb": {
    "handed": "ដាក់ស្នើ",
    "saveFailed": "ការរក្សាទុកបានបរាជ័យ",
    "examList": "បញ្ជីសំណួរប្រលង"
  },
  "research_zlb": {
    "afternoon": "PM",
    "all": "ទាំងអស់",
    "allCalendar": "របៀបវារៈទាំងអស់",
    "alumniBook": "សមាជិក",
    "broadcast": "x ចាប់ផ្តើមផ្សាយផ្ទាល់",
    "carriedout": "កំពុងដំណើរការ",
    "certificate": "វិញ្ញាបនប័ត្រ",
    "comment": "មតិ",
    "comments": "មតិ x ទាំងអស់",
    "courses": "ឯកសារយោង",
    "curDis": "កំពុងបន្ត",
    "default": "មិន​បាន​ចាប់​ផ្តើ​ម",
    "delete": "លុបចោល",
    "detail": "ព័ត៍មានលម្អិត",
    "discuss": "វេទិកា",
    "end": "បានបញ្ចប់",
    "endAssess": "ការវាយតម្លៃត្រូវបានបញ្ចប់",
    "enterAssess": "ចាប់ផ្តើមការវាយតម្លៃ",
    "assessButton": "មតិត្រឡប់",
    "evaluation": "ការវាយតម្លៃ",
    "fileAcept": "ប្រភេទឯកសារមិនត្រឹមត្រូវ។ សូមបង្ហោះម្តងទៀត។",
    "fileSize10": "ឯកសារដែលបានជ្រើសរើសលើសពី 10m ។ សូមបង្ហោះម្តងទៀត។",
    "hisDis": "ប្រវត្តិ",
    "lecture": "ឯកសារយោង",
    "live": "ផ្សាយផ្ទាល់",
    "livebroadcast": "ផ្សាយ​ផ្ទាល់",
    "minutes": "x នាទីមុន",
    "month": "ខែ",
    "morning": "AM",
    "noDiscussion": "គ្មានសិក្ខាសាលា",
    "noSchedule": "គ្មានរបៀបវារៈ",
    "notice": "សេចក្តីជូនដំណឹង",
    "notification": "សេចក្តីជូនដំណឹងមិនទាន់អាន",
    "offline": "ការបង្រៀនទល់មុខគ្នា",
    "onging": "កំពុង​ដំណើរការ",
    "online": "អនឡាញ",
    "operation": "កិច្ចការ",
    "over": "បានបញ្ចប់",
    "participated": "បានចូលរួមរួចហើយ",
    "notParticipate": "មិនទាន់បានចូលរួម",
    "failedCourse": "មិនបានជាប់",
    "passedCourse": "ជាប់",
    "preparation": "ការរៀបចំកិច្ចការ",
    "preparations": "ការរៀបចំកិច្ចការ",
    "preschoolLecture": "ការបង្រៀនសាកល្បង",
    "questionnaire": "កម្រងសំណួរ",
    "questionType ": "ពហុ​ជម្រើស (មានចម្លើយតែមួយគឺត្រឹមត្រូវ គូសចោលចម្លើយដែលមិនត្រឹមត្រូវទាំងអស់)",
    "readySay": "ខ្ញុំចង់និយាយថា",
    "replies": "អ្នកមានការឆ្លើយតបថ្មី x",
    "save": "រក្សាទុក",
    "schedule": "របៀបវារៈ",
    "searchC": "ស្វែងរកប្រធានបទដែលអ្នកចាប់អារម្មណ៍",
    "seeAssess": "បើកមើលការវាយតម្លៃ",
    "submit": "ដាក់ស្នើ",
    "submitHomewor": "បោះបង់",
    "task": "កិច្ចការ",
    "taskToday": "កិច្ចការសម្រាប់ថ្ងៃនេះ",
    "video": "វីដេអូ",
    "week": "សប្តាហ៍",
    "yourcomment": "សរសេរមតិយោបល់របស់អ្នក",
    "legend": "ចំណងជើង",
    "sunday": "ថ្ងៃអាទិត្យ",
    "monday": "ថ្ងៃច័ន្ទ",
    "tuesday": "ថ្ងៃអង្គារ",
    "wednesday": "ថ្ងៃពុធ",
    "thursday": "ថ្ងៃព្រហស្បតិ៍",
    "friday": "ថ្ងៃសុក្រ",
    "saturday": "ថ្ងៃសៅរ៍",
    "consult": "ឯកសារយោង",
    "schedules": "កិច្ចការ",
    "calendar": "ប្រតិទិន",
    "waitAssesment": "កម្រងសំណួរដែលត្រូវដាក់ស្នើ",
    "year": "ឆ្នាំ",
    "day": "ថ្ងៃ",
    "preview": "មើលជាមុន",
    "resource": "ទាញយក"
  },
  "retrieve_zlb": {
    "emailEmpty": "អាសយដ្ឋានអ៊ីម៉ែលមិនអាចទទេបានទេ។",
    "emailVerif": "ការផ្ទៀងផ្ទាត់អ៊ីម៉ែល"
  },
  "task_zlb": {
    "downF": "ទាញយកឯកសារភ្ជាប់",
    "repeatUp": "បង្ហោះឡើងវិញ",
    "ruY": "ប្រសិនបើឯកសារភ្ជាប់ត្រូវបានបង្ហោះនៅលើ APP វានឹងត្រូវបានសរសេរជាន់ពីលើ ប្រសិនបើអ្នកបង្ហោះឯកសារផ្សេងទៀតលើកុំព្យូទ័រ។",
    "submitC": "សូមបញ្ចូលអ្វីដែលអ្នកចង់ដាក់ស្នើរ",
    "uploadF": "បង្ហោះឯកសារភ្ជាប់"
  },
  "upload_zlb": {
    "clickHere": "ចុច​ទីនេះ",
    "limit": "ទម្រង់ឯកសារគាំទ្រ PNG, JPG ទំហំមិនអាចលើសពីនេះទេ",
    "preview": "ការមើលជាមុនបន្ទាប់ពីកាបង្ហោះរូបភាព",
    "upload": "បង្ហោះ"
  },
  "index": {
    "setAsHomePage": "កំណត់ជាទំព័រដើម",
    "addCollection": "ដាក់ចូលចំណូលចិត្ត",
    "telephone": "លេខទាន់ហេតុការណ៍",
    "Help": "មជ្ឈមណ្ឌល​ជំនួយ",
    "SystemMessage": "ការជូនដំណឹងអំពីប្រព័ន្ធ",
    "message": "សារ​ជា​ឯកជន",
    "emptyMessage": "លុបចោល",
    "checkAllMessage": "បើកមើលទាំងអស់",
    "noMessage": "គ្មានទិន្នន័យ",
    "fullScreen": "ការបង្ហាញពេញអេក្រង់",
    "ExitSystem": "ចេញពីប្រព័ន្ធនេះ",
    "back": "ក្រោយ",
    "top": "ខាងលើ",
    "backToTop": "ទៅខាងលើវិញ",
    "homePage": "ទំព័រដើម",
    "favoriteTips": "ដោយសារដែនកំណត់នៃកម្មវិធីរុករក 360 / Google សូមចុច Ctrl + D ដើម្បីប្រមូលដោយដៃ!",
    "autoSetHomeTips": "កម្មវិធីរុករករបស់អ្នកមិនគាំទ្រការកំណត់ទំព័រដើមដោយស្វ័យប្រវត្តិ សូមប្រើម៉ឺនុយកម្មវិធីរុករក ដើម្បីកំណត់វាដោយដៃ!",
    "currentUser": "អ្នកប្រើប្រាស់បច្ចុប្បន្ន",
    "userHead": "រូបភាពប្រវត្តិរូប",
    "accountPassword": "ពាក្យសម្ងាត់គណនី",
    "change": "បច្ចុប្បន្នភាព",
    "head": "រូបភាពប្រវត្តិរូប",
    "continueStudy": "បន្ត",
    "startStudy": "ចាប់ផ្តើមរៀន"
  },
  "course": {
    "count": "ទូទៅ",
    "item": "អត្ថបទ",
    "up": "ទំព័រ​មុន",
    "next": "ទំ​ព​រ័​បន្ទាប់",
    "items": "ក្នុងមួយទំព័រ",
    "go": "លោត​ទៅ",
    "page": "ទំព័រ",
    "man": "អ្នកប្រើប្រាស់",
    "score": "ពិន្ទុ",
    "courseYear": "ឆ្នាំ",
    "courseTeachers": "សាស្ត្រាចារ្យ",
    "noDesc": "គ្មានសេចក្តីផ្តើម",
    "teachersDesc": "ប្រវត្តិរូបគ្រូ",
    "checkLog": "បើកមើលកំណត់ត្រា",
    "startStudy": "ចាប់ផ្តើមរៀន",
    "JoinLearning": "ចូលរួម",
    "isEvaluate": "បានវាយតម្លៃ",
    "deleteNoteButton": "លុបចោល",
    "closeButton": "បិទ",
    "noteSource": "ពី"
  },
  "onlineclass": {
    "myScore": "ពិន្ទុរបស់ខ្ញុំ",
    "comments": "មតិ",
    "iknow": "ខ្ញុំដឹង",
    "detail": "ព័ត៍មានលម្អិត",
    "inforCertificate": "វិញ្ញាបនប័ត្រ",
    "wantTalk": "ខ្ញុំចង់ផ្តល់មតិយោបល់",
    "inputTalkContent": "សូមបញ្ចូលមតិ",
    "publish": "បញ្ចេញ",
    "undo": "បោះបង់",
    "reply": "ឆ្លើយតប",
    "delete": "លុបចោល",
    "Learned": "បានបញ្ចប់",
    "isDelete": "តើអ្នកពិតជាចង់លុបវាចោលមែនទេ?",
    "submitTime": "ពេលវេលាដាក់ស្នើ",
    "to": "ទៅ",
    "download": "ទាញយក"
  },
  "usercenter": {
    "htllo": "សួស្តី",
    "welcomeMessage": "សូមឱ្យមានថ្ងៃល្អ",
    "searchTips": "ស្វែងរកវគ្គសិក្សាដែលអ្នកចូលចិត្ត",
    "myCertificate": "វិញ្ញាបនប័ត្ររបស់ខ្ញុំ",
    "startQuestionnaire": "ចាប់ផ្តើមឆ្លើយវិញ្ញាសារ",
    "empty": "គ្មានអ្វីទេ",
    "confirmDelete": "ការលុបការបញ្ជាក់",
    "confirmDeleteTips": "តើអ្នកពិតជាចង់លុបវាចោលមែនទេ?",
    "delete": "លុបចោល",
    "integralscore": "Student points"
  },
  "play": {
    "endStudy": "បញ្ចប់ការសិក្សា",
    "tips": "ជំនួយ",
    "playTips": "ជំនួយ៖ សូមចុចប៊ូតុង \"បញ្ចប់ការរៀន\" នៅជ្រុងខាងស្តាំខាងលើ ដើម្បីចាកចេញ។ ប្រសិនបើអ្នកឈប់ការរៀនដោយបិទកម្មវិធីរុករក ពេលវេលារៀនរបស់អ្នកប្រហែលជាមិនត្រូវបានកត់ត្រាត្រឹមត្រូវទេ។",
    "notShowAgain": "កុំរំលឹកខ្ញុំម្តងទៀត",
    "gotIt": "ខ្ញុំដឹង",
    "chapter": "ជំពូក",
    "language": "ភាសា",
    "chapterText1": "ទេ។",
    "chapterText2": "ជំពូក",
    "note": "កំណត់ចំណាំ",
    "noteBlockTitle": "កំណត់ចំណាំ",
    "evaluate": "ការវាយតម្លៃ",
    "evaluateStar": "ផ្កាយ",
    "saveEvaluate": "ដាក់ស្នើ",
    "notePlaceholder": "សូមកត់ចំណាំ",
    "closeTips": "ការផ្លាស់ប្តូរដែលអ្នកបានធ្វើប្រហែលជាមិនត្រូវបានរក្សាទុកទេ",
    "closeButton": "ចាកចេញ",
    "autoStop": "បញ្ឈប់ការចាក់ដោយស្វ័យប្រវត្តិ",
    "autoStopTips": "អស់ពេលអសកម្មរបស់អ្នកប្រើប្រាស់។ ការចាក់សារជាថ្មីឈប់ដោយស្វ័យប្រវត្តិ។",
    "confirmOut": "តើអ្នកពិតជាចង់ឈប់​ចាក់មែនទេ?",
    "closeOrNot": "បិទ window បច្ចុប្បន្ន",
    "noCoursePlay": "មិនមានប្រភពដែលអាចចាក់បានទេនៅក្នុងវគ្គសិក្សាបច្ចុប្បន្ន",
    "attention": "សូម​មេត្តា​យកចិត្តទុកដាក់!"
  },
  "assessment_zlb": {
    "score": "ពិន្ទុ",
    "evalSuccess": "ការវាយតម្លៃដោយជោគជ័យ"
  },
  "undefined": {}
};